import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

import withProfile from 'hocs/withProfile';

import IconEmployees from 'icons/Employees';
import IconMaterials from 'icons/Materials';
import IconUsers from 'icons/Users';
import Logo from 'icons/Logo';
import IconGalleries from 'icons/Galleries';
import IconBiller from 'icons/Biller';
import { ReactComponent as IconSnoozes } from 'icons/Snoozes.svg';
import { ReactComponent as IconAudit } from 'icons/Audit.svg';
import { ReactComponent as Publications } from 'icons/Publications.svg';
import { ReactComponent as IconAR } from 'icons/ar.svg';
import { ReactComponent as IconUser } from 'icons/User.svg';

import Profile from 'containers/Profile';

import SidebarStyled from './SidebarStyled';
import IconLink from './IconLink';
import BottomBlock from './BottomBlock';
import Divider from './Divider';
import LogoLink from './LogoLink';
import IconTitle from './IconTitle';

const LINKS = [
  {
    title: 'Материалы',
    to: '/materials',
    permission: 'materials',
    icon: <IconMaterials />,
  }, {
    title: 'Монетизация',
    to: '/biller/requests/status/created',
    permission: 'biller',
    icon: <IconBiller />,
  }, {
    title: 'Публикации',
    to: '/publications/post_type/all/state/all/sort/-created_at',
    permission: 'publications',
    icon: <Publications />,
  }, {
    title: 'Галереи',
    to: '/galleries',
    permission: 'galleries',
    icon: <IconGalleries />,
  }, {
    title: 'Снузы',
    to: '/snoozes',
    permission: 'snoozes',
    icon: <IconSnoozes />,
    needDivider: true,
  }, {
    title: 'Пользователи',
    to: '/users',
    permission: 'users',
    icon: <IconUsers />,
  }, {
    title: 'AR',
    to: '/ar',
    permission: 'ar',
    icon: <IconAR />,
  }, {
    title: 'Сотрудники',
    to: '/employees',
    permission: 'employees',
    icon: <IconEmployees />,
    needDivider: true,
  }, {
    title: 'Журнал',
    to: '/audit',
    permission: 'audit',
    icon: <IconAudit />,
  }, {
    title: 'Аватар приложения',
    to: '/avatar',
    permission: 'avatar',
    icon: <IconUser />,
  },
];

export class Sidebar extends React.PureComponent {
  render() {
    return (
      <SidebarStyled>
        <LogoLink to="/">
          <Logo />
        </LogoLink>

        <Scrollbars
          autoHeight
          style={{ width: '110px' }}
          autoHeightMax="calc(100vh - 230px)"
        >
          {LINKS.map((link) => {
            if (!this.props.can({
              permission: link.permission,
              resource: 'pages',
            })) return null;

            return (
              <React.Fragment key={link.title}>
                <IconLink to={link.to} title={link.title}>
                  {link.icon}

                  <IconTitle>{link.title}</IconTitle>
                </IconLink>

                {link.needDivider &&
                  <Divider />
                }
              </React.Fragment>
            );
          })}
        </Scrollbars>

        <BottomBlock>
          <Profile />
        </BottomBlock>
      </SidebarStyled>
    );
  }
}


Sidebar.propTypes = {
  can: PropTypes.func,
};

Sidebar.defaultProps = {
  can: () => {},
};

export default withProfile(Sidebar);
